import React, { useEffect, useState } from 'react'
import api from "../../api/axios"; // Adjust path to your axios.js
import { Link } from 'react-router-dom';


const Categories = () => {

    const [categories, setCategories] = useState([]);

    useEffect(() => {
        api.get("/categories")
            .then((res) => {
                // res.data.data = [{id, name, slug, image}, ...]
                const formattedCategories = res.data.data.map(cat => ({
                    name: cat.name,
                    slug: cat.slug,
                    sub: [], // you can fetch subcategories later if needed
                }));
                setCategories(formattedCategories);
            })
            .catch((err) => console.error(err));
    }, []);



    return (
        <div>


            <h3 style={{ fontFamily: 'Montserrat, sans-serif' }} className="font-bold mb-8 uppercase text-[11px] tracking-[0.2em] text-black border-l-4 border-[#FFAA00] pl-3">
                Catégories
            </h3>


            <ul className="space-y-4 text-sm font-medium text-gray-500">
                {categories.map((cat) => (

                    <li key={cat.name} className="group">
                        <Link
                            to={`/categorie/${cat.slug}`}
                            className="hover:text-[#FFAA00] transition-colors"
                        >
                            {cat.name}
                        </Link>
                    </li>

                ))}

            </ul>


        </div>
    )
}

export default Categories